import { Star } from "lucide-react";

const FeedbackCard = ({ feedback }) => {
  return (
    <div className="h-72 items-center rounded-2xl p-6 shadow-sm transition hover:shadow-md rounded-3xl border border-green-600/30 bg-gradient-to-br from-black via-neutral-950 to-green-950/40">
      
      {/* Estrelas */}
      <div className="mb-3 flex gap-1 text-center justify-center">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            size={12}
            className={
              index < feedback.rating
                ? "fill-yellow-400 text-yellow-400"
                : "text-gray-300"
            }
          />
        ))}
      </div>

      <p className="text-white leading-relaxed text-center">
        “{feedback.message}”
      </p>

      <div className="mt-6 ">
        <p className="font-semibold text-white text-center">
          {feedback.name}
        </p>
      </div>
    </div>
  );
};

export default FeedbackCard;
 